import { AutoComplete, Button, Space } from "antd";
import {
  BaseOptionType,
  DefaultOptionType,
  RefSelectProps,
} from "antd/es/select";
import { useState, forwardRef, useRef, useImperativeHandle } from "react";
import { SearchIcon } from "src/assets/icons/SearchIcon";

type Props = {
  options: (BaseOptionType | DefaultOptionType)[] | undefined;
  onSearch?: (value: string) => void;
};

export interface QueryInputRef {
  clear: () => void;
  focus: () => void;
}

const QueryInput = forwardRef<QueryInputRef, Props>(
  ({ options, onSearch }, ref) => {
    const [value, setValue] = useState("");
    const autoCompleteRef = useRef<RefSelectProps>(null);

    useImperativeHandle(ref, () => ({
      clear: () => {
        setValue("");
      },
      focus: () => {
        autoCompleteRef.current?.focus();
      },
    }));

    const handleSelect = (selected: string) => {
      const words = value.split(" ");
      const lastWord = words[words.length - 1];
      const bracketMatch = lastWord.match(/^([([{]+)/);
      const bracketPrefix = bracketMatch ? bracketMatch[1] : "";

      words[words.length - 1] = bracketPrefix + selected;
      setValue(words.join(" ") + " ");
    };

    const handleChange = (data: string) => {
      setValue(data);
    };

    return (
      <Space.Compact className="w-full">
        <AutoComplete
          allowClear
          className="w-full"
          value={value}
          options={options}
          onSelect={handleSelect}
          onChange={handleChange}
          placeholder={"Search with a query..."}
          filterOption={(inputValue, option) => {
            let lastWord = inputValue.split(" ").pop() || "";
            lastWord = lastWord.replace(/^[([{]+/, "");
            return (
              option!.value.toUpperCase().indexOf(lastWord.toUpperCase()) !== -1
            );
          }}
          ref={autoCompleteRef}
        />
        <Button
          className="bg-primary text-white disabled:bg-gray-300"
          disabled={!value}
          onClick={() => {
            onSearch?.(value.trim());
          }}
        >
          <SearchIcon />
        </Button>
      </Space.Compact>
    );
  },
);

export default QueryInput;
